import styled from 'styled-components';
import MaritalStatus from '../../../components/fields/MaritalStatusField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheMaritalStatusField = styled(MaritalStatus)<Brightness>`
    ${PorscheSelectCss}
`;

const MaritalStatusField = withPorscheSelect(PorscheMaritalStatusField);
export default MaritalStatusField;
